import { Action } from '@ngrx/store';
/** RoutingActionType */
export enum RoutingActionType {
    START_ROUTING = 'START_ROUTING',
}
/** RoutingAction */
export class RoutingAction implements Action {
    /** type */
    public readonly type = RoutingActionType.START_ROUTING;
    /** constructor */
    public constructor (public payload: {
        /** url */
        url: string,
        /** replaceurl */
        replaceUrl?: boolean,
        /** targeturl */
        targetUrl?: string}) { }
}
